import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./HomePage.css";
import ProductCard from "../common/ProductCard";
import { DIRECT_PRODUCTS } from "../../data/ProductData";

const NewArrivalsSlider = () => {
  const [newArrivals, setNewArrivals] = useState([]);

  useEffect(() => {
    // Get new arrivals from the same data source as the NewArrivalsPage
    const fetchNewArrivals = () => {
      try {
        const arrivals = [...DIRECT_PRODUCTS]
          .filter(p => p.inStock)
          // Sort by ID in descending order (assuming higher IDs are newer products)
          // This ensures products with the latest IDs appear at the top
          .sort((a, b) => {
            // First try to sort by numeric ID if the format is 'direct123'
            const aIdNum = a.id.replace(/\D/g, '');
            const bIdNum = b.id.replace(/\D/g, '');
            
            if (aIdNum && bIdNum) {
              return parseInt(bIdNum) - parseInt(aIdNum);
            }
            
            // Fallback to creation date if IDs don't have numeric components
            return new Date(b.createdAt) - new Date(a.createdAt);
          })
          .slice(0, 5); // Limit to 5 products for the slider
        
        setNewArrivals(arrivals);
      } catch (error) {
        console.error('Error fetching new arrivals:', error);
      }
    };

    fetchNewArrivals();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 100,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="new-arrivals">
      <h2 className="section-title">New Arrivals</h2>
      <p className="section-subtitle">
        Explore our latest collection of futuristic jewelry
      </p>
      <div className="slider-container">
        <Slider {...settings}>
          {newArrivals.map((item) => (
            <div key={item.id} className="slider-item">
              <ProductCard product={item} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default NewArrivalsSlider;
